import { Component, Input, OnInit, ViewChild } from '@angular/core';
import * as _ from 'underscore';
import * as jQuery from 'jquery';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS, PREFIXES } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { AnalyticsCoreURLService } from '../../../../reporting/analytics-core/services/analytics-core.url.service';
import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { WidgetLibraryService } from '../../services/widget-library.service';
@Component({
	selector: 'app-sem-ad-assets',
	templateUrl: './sem-ad-assets.component.html',
	styleUrls: ['./sem-ad-assets.component.css']
})
export class SemAdAssetsComponent implements OnInit {
	@ViewChild('myTable') table: any;

	@Input() sectiontitle: string;
	@Input() key: string;
	@Input() downloadconfig: string;
	@Input() datatableconfig;
	@Input() sectionclass: string;
	@Input() sortdataby: string;
	@Input() legend;
	@Input() downloadcsvcolumns: any;
	@Input() colcount: any;
	@Input() nodatamessage: string;
	@Input() uikitresponseconfig: any;
	@Input() customchartconfiguration: any;
	@Input() seriesviewconfiguration: any;

	public hasData: boolean;
	public reloadSubscription;
	public widgetDataSubscription;
	public creatives: any = [];
	public showLoad = true;
	public formattedData = [];
	public downloadConfiguration: DownloadConfig;
	public currentSortingKey;
	public currentOpenedAd = -1;
	public currentOpenedAdGroup = -1;
	public isR13: boolean = false;
	public isR10: boolean = false;
	public isR6: boolean = false;
	public adgroup_id;
	public tooltipOptions = {
		animation: 'fade',
		arrow: true,
		duration: 750,
		dynamicTitle: true,
		position: 'top',
		scale: 'small'
	};
	tableConfig: any;
	columns: any[];
	itemsPerPage: any;
	public resourceLibraryPermission: boolean = false;
	public resourceLibraryPermissionCheck: object = { permission: { flags: ['resourceLibrary'] } };
	public resourceLibrary;
	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected widgetLibraryService: WidgetLibraryService,
		protected AnalyticsCoreURLService: AnalyticsCoreURLService
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.isR6 = this.analyticsDataModel.config.version === 'R6' ? true : false;
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.datatableconfig = JSON.parse(decodeURI(this.datatableconfig));
		this.tableConfig = this.datatableconfig;
		this.columns = this.generateColumnConfigurationForDataTable();
		this.downloadcsvcolumns = this.downloadcsvcolumns ? JSON.parse(decodeURI(this.downloadcsvcolumns)) : [];
		this.itemsPerPage = this.colcount != 'undefined' && this.colcount != 'null' ? this.colcount : 10;
		if (!this.nodatamessage || this.nodatamessage === 'undefined' || this.nodatamessage === 'null') {
			this.nodatamessage = 'No data to display';
		}
		this.resourceLibraryPermission = this.analyticsDataModel.checkComponentForPermission(
			this.resourceLibraryPermissionCheck
		);
		this.sortdataby = this.sortdataby && !(this.sortdataby === undefined) ? this.sortdataby : 'clicks';
		this.resourceLibrary = this.isR6
			? 'https://nexstardigital.helpdocsonline.com/sem_asset_reporting'
			: this.AnalyticsCoreURLService.serviceURL + '/Resource_Library/Content/Products/SEM/SEM_asset_reporting.htm';
		this.requestData();
	}
	requestData(): void {
		this.hasData = true;
		this.showLoad = true;
		this.widgetDataSubscription = this.analyticsService.processCustomServiceRequest(this.key).subscribe((res: any) => {
			this.showLoad = false;
			if (res.success && res.data?.length > 0) {
				this.processResponseData(res.data);
			} else {
				this.hasData = false;
			}
		});
	}
	processResponseData(responseData) {
		if (responseData.length > 0) {
			this.hasData = true;
			this.formattedData = [];
			this.creatives = this.mapResponseDataToInterface(responseData);
			this.creatives = this.groupArrayOfObjectsByAdgroup(this.creatives, 'adGroupId');
			this.adgroup_id = Object.keys(this.creatives);
			this.adgroup_id.forEach((element) => {
				let eachAdgroup = {
					adGroup: this.creatives[element][0]['adGroup'],
					adGroupId: element,
					assets: []
				};
				let assets = this.groupArrayOfObjectsByAdgroup(this.creatives[element], 'adId');
				let assetIds = Object.keys(assets);
				assetIds.forEach((id) => {
					let eachAsset = {};
					let value: any = '';
					let type = '';
					if (assets[id][0]['extensionName'] == 'STRUCTURED_SNIPPET') {
						value =
							assets[id][0]['assetType'] == 'structuredsnippetheader'
								? assets[id][0]['value'] + ': ' + assets[id][1]['value']
								: assets[id][1]['value'] + ': ' + assetIds[id][0]['value'];
						type = 'Structured Snippet';
					} else if (assets[id][0]['extensionName'] == 'SITELINK') {
						let siteLinkText = assets[id].find((type) => type.assetType == 'sitelinktext')['value'];
						let siteLinkDesc1 =
							assets[id].filter((type) => type.assetType.match('sitelinkdescription1')).length > 0
								? assets[id].filter((type) => type.assetType.match('sitelinkdescription1'))[0]['value']
								: '';
						let siteLinkDesc2 =
							assets[id].filter((type) => type.assetType.match('sitelinkdescription2')).length > 0
								? assets[id].filter((type) => type.assetType.match('sitelinkdescription2'))[0]['value']
								: '';
						value = [siteLinkText, siteLinkDesc1 + ' ' + siteLinkDesc2];
						type = 'Sitelink';
					} else if (assets[id][0]['extensionName'] == 'CALL') {
						value = assets[id].find((type) => type.assetType == 'callphonenumber')['value'];
						type = 'Call';
					} else if (assets[id][0]['extensionName'].match('IMAGE')) {
						(value = '[Image Placeholder]'), (type = 'Image');
					} else if (assets[id][0]['extensionName'].match('LOCATION')) {
						(value = ''),
							assets[id].forEach((item) => {
								if (
									item.assetType == 'locationaddressline1' ||
									item.assetType == 'locationcity' ||
									item.assetType == 'locationprovince'
								) {
									value += item.value + ', ';
								}
							});
						value = value.substring(0, value.length - 2);
						type = 'Location';
					} else {
						(value = assets[id][0]['value']), (type = 'Callout');
					}
					eachAsset = {
						value: value,
						impressions: assets[id][0]['impressions'],
						clicks: assets[id][0]['clicks'],
						clickthroughrate: assets[id][0]['clickthroughrate'],
						extensionName: assets[id][0]['extensionName'],
						cost: assets[id][0]['cost'],
						assetType: type
					};
					eachAdgroup.assets.push(eachAsset);
				});
				eachAdgroup.assets = eachAdgroup.assets.sort((a, b) => {
					if (a['clicks'] > b['clicks']) {
						return -1;
					} else if (a['clicks'] < b['clicks']) {
						return 1;
					} else {
						if (a['impressions'] > b['impressions']) {
							return -1;
						} else {
							return 1;
						}
					}
				});
				this.formattedData.push(eachAdgroup);
			});
			this.formattedData = this.formattedData.sort((a, b) => {
				if (a['adGroup'] > b['adGroup']) {
					return 1;
				} else if (a['adGroup'] < b['adGroup']) {
					return -1;
				} else {
					return 0;
				}
			});
		} else {
			this.hasData = false;
		}
	}

	groupArrayOfObjectsByAdgroup(list, key) {
		return list.reduce(function (rv, x) {
			(rv[x[key]] = rv[x[key]] || []).push(x);
			return rv;
		}, {});
	}

	protected mapResponseDataToInterface(responseData) {
		const creativePerformances: any = [];
		for (const response of responseData) {
			const creativeObj: any = {};
			creativeObj.adGroup = UtilityService.isUndefinedOrNull(response.adgroup_name) ? 'Other' : response.adgroup_name;
			creativeObj.adGroupId = UtilityService.isUndefinedOrNull(response.adgroup_id) ? '' : response.adgroup_id;
			creativeObj.adId = UtilityService.isUndefinedOrNull(response.ad_id) ? '' : response.ad_id;
			creativeObj.assetType = UtilityService.isUndefinedOrNull(response.type) ? '' : response.type;
			creativeObj.extensionName = UtilityService.isUndefinedOrNull(response.extension_name)
				? ''
				: response.extension_name;
			creativeObj.value = UtilityService.isUndefinedOrNull(response.value) ? '' : response.value;
			creativeObj.clicks = parseFloat(response.click);
			creativeObj.impressions = parseFloat(response.impressions);
			creativeObj.clickthroughrate = ((creativeObj.clicks / creativeObj.impressions) * 100).toFixed(2);
			creativeObj.cost = parseFloat(response.cost);
			creativePerformances.push(creativeObj);
		}
		return creativePerformances;
	}

	generateColumnConfigurationForDataTable(): any[] {
		const dateSet = {
			depricatedDate: this.analyticsDataModel.depricatedDate,
			endDate: this.analyticsDataModel.endDate,
			goLiveDate: this.analyticsDataModel.goLiveDate,
			startDate: this.analyticsDataModel.startDate
		};
		const columnsConfig = UtilityService.checkForVisibilityPermissions(this.tableConfig.columns, dateSet);
		const sortedColumnConfig = _.sortBy(columnsConfig, 'columnOrder');
		const columns = [];
		for (const colConfig of sortedColumnConfig) {
			const colObj: any = {} as any;
			colObj.name = colConfig.columnName;
			colObj.shortName = colConfig.columnNameShort;
			colObj.prop = colConfig.columnKey;
			colObj.headerClass = colConfig.columnHeaderClass;
			colObj.cellClass = colConfig.columnCellClass;
			colObj.hasProgressBar = colConfig.columnHasProgressBar;
			colObj.showTitle = colConfig.columnShowTitle;
			colObj.columnKey = colConfig.columnKey;
			colObj.suffix = colConfig.columnSuffix;
			colObj.type = colConfig.columnType;
			colObj.flexGrow = colConfig.columnFlexGrow ?? 1;
			colObj.resizeable = false;
			colObj.columnHasTooltip = colConfig.columnHasTooltip;
			colObj.columnTooltip = colConfig.columnTooltip;
			columns.push(colObj);
		}
		return columns;
	}

	expand(key, index, value, flag): void {
		switch (key) {
			case 'adgroup':
				if (flag) {
					jQuery(
						`.sem-ad-assets .analytics-portlet-content .container-table .container-table-body .adgroups-rows .ads-details`
					).removeClass('expand');
					jQuery(
						`.sem-ad-assets .analytics-portlet-content .container-table .container-table-body .adgroups-rows .rows`
					).removeClass('expanded-row');
					jQuery(
						`.sem-ad-assets .analytics-portlet-content .container-table .container-table-body .adgroups-rows:nth-child(${
							index + 1
						}) .ads-details`
					).addClass('expand');
					jQuery(
						`.sem-ad-assets .analytics-portlet-content .container-table .container-table-body .adgroups-rows:nth-child(${
							index + 1
						}) .rows`
					).addClass('expanded-row');
					jQuery(
						`.sem-ad-assets .analytics-portlet-content .container-table .container-table-body .adgroups-rows .adgroup-values .closeIcon`
					).css({ display: 'none' });
					jQuery(
						`.sem-ad-assets .analytics-portlet-content .container-table .container-table-body .adgroups-rows .adgroup-values .openIcon`
					).css({ display: 'initial' });
					jQuery(
						`.sem-ad-assets .analytics-portlet-content .container-table .container-table-body .adgroups-rows:nth-child(${
							index + 1
						}) .adgroup-values .openIcon`
					).css({ display: 'none' });
					jQuery(
						`.sem-ad-assets .analytics-portlet-content .container-table .container-table-body .adgroups-rows:nth-child(${
							index + 1
						}) .adgroup-values .closeIcon`
					).css({ display: 'initial' });
					this.formattedData = [...this.formattedData];
				} else {
					jQuery(
						`.sem-ad-assets .analytics-portlet-content .container-table .container-table-body .adgroups-rows .ads-details`
					).removeClass('expand');
					jQuery(
						`.sem-ad-assets .analytics-portlet-content .container-table .container-table-body .adgroups-rows .rows`
					).removeClass('expanded-row');
					jQuery(
						`.sem-ad-assets .analytics-portlet-content .container-table .container-table-body .adgroups-rows .ads-details .ads-rows .combinations`
					).removeClass('expand');
					jQuery(
						`.sem-ad-assets .analytics-portlet-content .container-table .container-table-body .adgroups-rows:nth-child(${
							index + 1
						}) .adgroup-values .openIcon`
					).css({ display: 'initial' });
					jQuery(
						`.sem-ad-assets .analytics-portlet-content .container-table .container-table-body .adgroups-rows:nth-child(${
							index + 1
						}) .adgroup-values .closeIcon`
					).css({ display: 'none' });
					this.formattedData = [...this.formattedData];
				}
				break;
			case 'ads':
				if (flag) {
					jQuery(
						`.sem-ad-assets .analytics-portlet-content .container-table .container-table-body .adgroups-rows .ads-details .ads-rows .combinations`
					).removeClass('expand');
					jQuery(
						`.sem-ad-assets .analytics-portlet-content .container-table .container-table-body .adgroups-rows:nth-child(${
							index + 1
						}) .ads-details .ads-rows:nth-child(${value + 1}) .combinations`
					).addClass('expand');
					jQuery(
						`.sem-ad-assets .analytics-portlet-content .container-table .container-table-body .adgroups-rows .ads-details .ads-rows .openIcon`
					).css({ display: 'initial' });
					jQuery(
						`.sem-ad-assets .analytics-portlet-content .container-table .container-table-body .adgroups-rows .ads-details .ads-rows .closeIcon`
					).css({ display: 'none' });
					jQuery(
						`.sem-ad-assets .analytics-portlet-content .container-table .container-table-body .adgroups-rows:nth-child(${
							index + 1
						}) .ads-details`
					).addClass('show-content');
					jQuery(
						`.sem-ad-assets .analytics-portlet-content .container-table .container-table-body .adgroups-rows:nth-child(${
							index + 1
						}) .ads-details .ads-rows:nth-child(${value + 1}) .openIcon`
					).css({ display: 'none' });
					jQuery(
						`.sem-ad-assets .analytics-portlet-content .container-table .container-table-body .adgroups-rows:nth-child(${
							index + 1
						}) .ads-details .ads-rows:nth-child(${value + 1}) .closeIcon`
					).css({ display: 'initial' });
					this.formattedData = [...this.formattedData];
				} else {
					jQuery(
						`.sem-ad-assets .analytics-portlet-content .container-table .container-table-body .adgroups-rows .ads-details .ads-rows .combinations`
					).removeClass('expand');
					jQuery(
						`.sem-ad-assets .analytics-portlet-content .container-table .container-table-body .adgroups-rows:nth-child(${
							index + 1
						}) .ads-details`
					).addClass('expand');
					jQuery(
						`.sem-ad-assets .analytics-portlet-content .container-table .container-table-body .adgroups-rows:nth-child(${
							index + 1
						}) .ads-details`
					).removeClass('show-content');
					jQuery(
						`.sem-ad-assets .analytics-portlet-content .container-table .container-table-body .adgroups-rows .ads-details .ads-rows .openIcon`
					).css({ display: 'initial' });
					jQuery(
						`.sem-ad-assets .analytics-portlet-content .container-table .container-table-body .adgroups-rows .ads-details .ads-rows .closeIcon`
					).css({ display: 'none' });
					jQuery(
						`.sem-ad-assets .analytics-portlet-content .container-table .container-table-body .adgroups-rows:nth-child(${
							index + 1
						}) .ads-details .ads-rows:nth-child(${value + 1}) .openIcon`
					).css({ display: 'initial' });
					jQuery(
						`.sem-ad-assets .analytics-portlet-content .container-table .container-table-body .adgroups-rows:nth-child(${
							index + 1
						}) .ads-details .ads-rows:nth-child(${value + 1}) .closeIcon`
					).css({ display: 'none' });
					this.formattedData = [...this.formattedData];
				}
				break;
			default:
				break;
		}
	}

	scrollGraph(adsList, i): void {
		if (i < 0) {
			i = adsList.length - 1;
		} else if (i >= adsList.length) {
			i = 0;
		}
		jQuery('.ads-details').animate(
			{
				scrollTop: jQuery('.ads-details').scrollTop() + jQuery('#ad_' + i).position().top
			},
			100
		);
	}

	sortDataBasedOnKey(key, type, index): void {
		this.sortdataby = key;
		if (type !== 'string') {
			jQuery('.sem-RSA.sem-ad-assets .analytics-portlet-content .container-table .header .column-name').removeClass(
				'active'
			);
			jQuery('.sem-RSA.sem-ad-assets .analytics-portlet-content .container-table .header .column-name').removeClass(
				'ascending'
			);
			jQuery('.sem-RSA.sem-ad-assets .analytics-portlet-content .container-table .header .column-name').removeClass(
				'descending'
			);
			jQuery(
				`.sem-RSA.sem-ad-assets .analytics-portlet-content .container-table .header .column-name:nth-child(${
					index + 1
				})`
			).addClass('active');
			if (this.currentSortingKey && this.currentSortingKey != key) {
				this.formattedData.sort((a, b) => {
					return a[key] - b[key];
				});
				jQuery(
					`.sem-RSA.sem-ad-assets .analytics-portlet-content .container-table .header .column-name:nth-child(${
						index + 1
					})`
				).addClass('ascending');
				this.currentSortingKey = key;
			} else if (this.currentSortingKey == key) {
				this.formattedData.sort((a, b) => {
					return b[key] - a[key];
				});
				jQuery(
					`.sem-RSA.sem-ad-assets .analytics-portlet-content .container-table .header .column-name:nth-child(${
						index + 1
					})`
				).addClass('descending');
				this.currentSortingKey = null;
			} else {
				this.formattedData.sort((a, b) => {
					return a[key] - b[key];
				});
				jQuery(
					`.sem-RSA.sem-ad-assets .analytics-portlet-content .container-table .header .column-name:nth-child(${
						index + 1
					})`
				).addClass('ascending');
				this.currentSortingKey = key;
			}
		} else {
			jQuery('.sem-RSA.sem-ad-assets .analytics-portlet-content .container-table .header .column-name').removeClass(
				'active'
			);
			jQuery('.sem-RSA.sem-ad-assets .analytics-portlet-content .container-table .header .column-name').removeClass(
				'ascending'
			);
			jQuery('.sem-RSA.sem-ad-assets .analytics-portlet-content .container-table .header .column-name').removeClass(
				'descending'
			);
			jQuery(
				`.sem-RSA.sem-ad-assets .analytics-portlet-content .container-table .header .column-name:nth-child(${
					index + 1
				})`
			).addClass('active');
			if (this.currentSortingKey && this.currentSortingKey != key) {
				this.formattedData.sort((a, b) => (a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0));
				jQuery(
					`.sem-RSA.sem-ad-assets .analytics-portlet-content .container-table .header .column-name:nth-child(${
						index + 1
					})`
				).addClass('ascending');
				this.currentSortingKey = key;
			} else if (this.currentSortingKey == key) {
				this.formattedData.sort((a, b) => (a[key] < b[key] ? -1 : b[key] < a[key] ? 1 : 0));
				jQuery(
					`.sem-RSA.sem-ad-assets .analytics-portlet-content .container-table .header .column-name:nth-child(${
						index + 1
					})`
				).addClass('descending');
				this.currentSortingKey = null;
			} else {
				this.formattedData.sort((a, b) => (a[key] > b[key] ? -1 : b[key] > a[key] ? 1 : 0));
				jQuery(
					`.sem-RSA.sem-ad-assets .analytics-portlet-content .container-table .header .column-name:nth-child(${
						index + 1
					})`
				).addClass('ascending');
				this.currentSortingKey = key;
			}
		}
	}

	downloadCSV(e) {
		e.preventDefault();
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key,
			this.downloadConfiguration.fileName,
			this.downloadcsvcolumns,
			null,
			this.downloadConfiguration.newTabCsvQueryKey,
			this.downloadConfiguration.newTabCsvFileName
		);
	}
}
